import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Restablecer() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) return toast.error("La contraseña debe tener al menos 8 caracteres.");
    if (pwd !== pwd2) return toast.error("Las contraseñas no coinciden.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, nueva_password: pwd });
      toast.success("Contraseña actualizada. Ya puedes iniciar sesión.");
      navigate("/login");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA] px-6" data-testid="restablecer-page">
        <div className="text-center max-w-md">
          <h2 className="text-xl font-black text-[#0E2A47]">Enlace no válido</h2>
          <p className="text-sm text-[#0E2A47]/70 mt-2">Falta el token de recuperación. Solicita un enlace nuevo.</p>
          <Link to="/recuperar"><Button className="mt-5 bg-[#FF5625] hover:bg-[#E0451A] text-white">Solicitar enlace</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA] px-6" data-testid="restablecer-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <ShieldCheck className="text-[#FF5625]" size={28} />
          <span className="font-black text-xl tracking-tighter text-[#0E2A47]">AuditReady<span className="text-[#FF5625]">.</span></span>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-[#E2E8F0] shadow-sm p-8" data-testid="restablecer-form">
          <h2 className="text-2xl font-black tracking-tight text-[#0E2A47]">Nueva contraseña</h2>
          <p className="text-sm text-[#0E2A47]/60 mt-1 mb-6">Elige una contraseña segura (mínimo 8 caracteres).</p>
          <div className="space-y-4">
            <div>
              <Label className="text-xs font-bold uppercase tracking-wider text-[#0E2A47]/60">Nueva contraseña</Label>
              <Input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)}
                placeholder="••••••••" className="mt-1.5" data-testid="restablecer-pwd" />
            </div>
            <div>
              <Label className="text-xs font-bold uppercase tracking-wider text-[#0E2A47]/60">Repite la contraseña</Label>
              <Input type="password" required value={pwd2} onChange={(e) => setPwd2(e.target.value)}
                placeholder="••••••••" className="mt-1.5" data-testid="restablecer-pwd2" />
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="restablecer-submit"
            className="w-full mt-6 bg-[#FF5625] hover:bg-[#E0451A] text-white font-semibold">
            {loading ? <><Loader2 size={16} className="mr-2 animate-spin" />Guardando…</> : "Guardar contraseña"}
          </Button>
        </form>
      </div>
    </div>
  );
}
